import request from '@/axios'

export function storePayment (payload, customer_id) {
  return request({
    url:`/ClientUser/payment/store/paypal/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function stripeCreateTokenApi () {
  return request({
    url:'ClientUser/stripe/setup/intent',
    method:'GET'
  })
}


export function stripeCreatePaymentApi (payload) {
  return request({
    url:'ClientUser/stripe/create-payment',
    method:'POST',
    data:payload
  })
}
export function userCardListApi () {
  return request({
    url:'ClientUser/stripe/user/userCardList',
    method:'GET'
  })
}

export function deleteCardApi (payload) {
  return request({
    url:'ClientUser/stripe/user/deleteCard',
    method:'POST',
    data:payload
  })
}


export function goCardLessCreatePayment (payload = null) {
  return request({
    url:'ClientUser/goCardLess/create-payment ',
    method:'POST',
    data:payload
  })
}

export function paypalErrorApi (customer_id, payload) {
  return request({
    url:`payment/paypal/error/${customer_id}`,
    method:'POST',
    data:payload
  })
}


export function goCardCompleteRediret (query) {
  return request({
    url:'ClientUser/goCardLess/complete_redirect',
    method:'GET',
    params:query
  })
}

export function getPaypalClientId (course_customer_id) {
  return request({
    url: `ClientUser/payment/getClientId/${course_customer_id}`,
    method:'GET'
  })
}

